export default __webpack_public_path__ + "static/media/drip-pan1.c1ea4267.png";